module.exports = __webpack_public_path__ + "Proxima Nova Regular.58dbd36c5542ce4ec9d9.eot";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/fonts/Proxima Nova Regular.eot
// module id = ../../../../../fonts/Proxima Nova Regular.eot
// module chunks = 2